







































import {Vue, Component} from 'vue-property-decorator';
import ContractorServiceLogList from "@/components/payroll/business/services/ContractorServiceLogList.vue";
import EmployerServiceLogList from "@/components/payroll/business/services/EmployerServiceLogList.vue";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import PayeeInvoiceList from "@/components/payroll/business/services/invoice/PayeeInvoiceList.vue";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {InvoiceSummary} from "@/components/payroll/business/services/ServiceDTO";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";

type Tabs = "PAY_INVOICE" | "VIEW_INVOICE" | "CONTRACTOR_WORK" | "SERVICE_LOG"

@Component({
	components: {InvoiceList: PayeeInvoiceList, InvoiceCreationSlider, EmployerServiceLogList, ContractorServiceLogList}
})
export default class ContractWork extends Vue {

	private currentTab: Tabs = "PAY_INVOICE"

	private setTab(tab: Tabs) {
		this.currentTab = tab
	}

	private unpaid: InvoiceSummary | null = null
	private paid: InvoiceSummary | null = null

	mounted() {
		Application.startLoading()
		this.loadUnpaidTotal()
			.then(this.loadPaidTotal)
			.finally(Application.stopLoading)
	}

	private loadUnpaidTotal() {
		return ServiceInvoiceOrchestrator.getUnpaidTotal(this.$wss.getCurrent.id).then(
			res => {
				this.unpaid = res.data
			},
			err => processError(err, this)
		)
	}

	private loadPaidTotal() {
		return ServiceInvoiceOrchestrator.getPaidTotal(this.$wss.getCurrent.id).then(
			res => {
				this.paid = res.data
			},
			err => processError(err, this)
		)
	}

	get unpaidValue(): string {
		if (this.unpaid) {
			switch (this.currentTab) {
				case "PAY_INVOICE":
				case "SERVICE_LOG":
					return "$" + this.unpaid.payee.toLocaleString("en-US", { minimumFractionDigits: 2 })
				default:
					return "$" + this.unpaid.payer.toLocaleString("en-US", { minimumFractionDigits: 2 })
			}
		} else {
			return "$0.00"
		}
	}

	get paidValue(): string {
		if (this.paid) {
			switch (this.currentTab) {
				case "PAY_INVOICE":
				case "SERVICE_LOG":
					return "$" + this.paid.payee.toLocaleString("en-US", { minimumFractionDigits: 2 })
				default:
					return "$" + this.paid.payer.toLocaleString("en-US", { minimumFractionDigits: 2 })
			}
		} else {
			return "$0.00"
		}
	}

}
